export const EyeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="10"
    viewBox="0 0 14 10"
    fill="none"
  >
    <path
      d="M6.81794 6.81819C7.82209 6.81819 8.63612 6.00416 8.63612 5.00001C8.63612 3.99585 7.82209 3.18182 6.81794 3.18182C5.81378 3.18182 4.99976 3.99585 4.99976 5.00001C4.99976 6.00416 5.81378 6.81819 6.81794 6.81819Z"
      fill="url(#paint0_linear_720_35342)"
    />
    <path
      d="M13.6089 4.84545C13.0743 3.46257 12.1462 2.26664 10.9393 1.40549C9.73236 0.544343 8.29957 0.055715 6.81799 0C5.33641 0.055715 3.90362 0.544343 2.69672 1.40549C1.48981 2.26664 0.561698 3.46257 0.0270793 4.84545C-0.00902645 4.94532 -0.00902645 5.05468 0.0270793 5.15455C0.561698 6.53743 1.48981 7.73336 2.69672 8.59451C3.90362 9.45566 5.33641 9.94429 6.81799 10C8.29957 9.94429 9.73236 9.45566 10.9393 8.59451C12.1462 7.73336 13.0743 6.53743 13.6089 5.15455C13.645 5.05468 13.645 4.94532 13.6089 4.84545ZM6.81799 7.95455C6.23363 7.95455 5.6624 7.78126 5.17653 7.45661C4.69066 7.13197 4.31197 6.67053 4.08834 6.13066C3.86472 5.59078 3.80621 4.99672 3.92021 4.4236C4.03422 3.85047 4.31561 3.32402 4.72881 2.91082C5.14201 2.49762 5.66846 2.21623 6.24159 2.10223C6.81471 1.98822 7.40877 2.04673 7.94864 2.27036C8.48852 2.49398 8.94995 2.87267 9.2746 3.35854C9.59925 3.84442 9.77253 4.41565 9.77253 5C9.77133 5.78323 9.45966 6.53403 8.90584 7.08785C8.35202 7.64168 7.60121 7.95334 6.81799 7.95455Z"
      fill="url(#paint1_linear_720_35342)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_720_35342"
        x1="4.92504"
        y1="5.00001"
        x2="6.79003"
        y2="3.14449"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0BADC2" />
        <stop offset="1" stopColor="#0AA5BE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_720_35342"
        x1="-0.280191"
        y1="5"
        x2="4.61893"
        y2="-1.64647"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0BADC2" />
        <stop offset="1" stopColor="#0AA5BE" />
      </linearGradient>
    </defs>
  </svg>
);
